import { Component, OnInit, Input } from '@angular/core';
import { KeyValue } from '../../../../../models/KeyValue';
import { PercPipe } from '../../../../../pipes/perc.pipe';
import { TooltipService } from '../../../../../services/tooltip-service';
import { User } from '../../../../../models/User';
import { PieChartData } from '../../../charts/models/PieChartData';

declare var jQuery;

@Component({
  selector: 'app-domain-fraud-traffic',
  templateUrl: './domain-fraud-traffic.component.html',
  styleUrls: ['./domain-fraud-traffic.component.scss']
})
export class DomainFraudTrafficComponent implements OnInit {
  @Input() data: any;
  @Input() appName: string;

  tooltipData: KeyValue[];
  headers = [];
  percPipe: PercPipe = new PercPipe();
  datacenters: any;

  pieChartData: Array<PieChartData> = [];

  get isFreemium(): boolean {
    return this.userService.isFreemium();
  }

  constructor(
    private tooltipService: TooltipService,
    private userService: User
  ) {
    this.tooltipData = this.tooltipService.getMap();
  }

  ngOnInit() {
    this.headers.push({
      class: 'col',
      text: 'DATA CENTER NAME',
      key: 'dcName',
      tooltipkey: ''
    });
    this.headers.push({
      class: 'col',
      text: 'TOTAL TRAFFIC',
      key: 'totalTrafficRatio',
      format: 'percent',
      tooltipkey: ''
    });
    setTimeout(fn => {
      jQuery('[data-toggle="tooltip"]').tooltip({ animation: false });
    }, 100);

    this.datacenters = this.data['ivtDistribution']['datacenters'];

    this.pieChartData = this.datacenters.map(item => {
      return {
        title: item?.dcName,
        value: item?.totalTrafficRatio,
        category: item?.dcName
      };
    });
  }
}
